import Vue from 'vue'
import VueRouter from 'vue-router'

import routes from './routes.js'

Vue.use(VueRouter);

/* Enable router*/
let router = new VueRouter({
    mode: 'history',
    routes,
    base: '/teller/'
});

export default router;



// WEBPACK FOOTER //
// ./src/route/index.js